/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import * as uxstackpb from '@uxstack/sdk-proto-js/uxstack/sdk/v1/sdk_pb';

export class EventContextUser extends uxstackpb.EventContextUser {
  constructor(properties?: uxstackpb.EventContextUser) {
    super(properties);

    if (this.countryCode === '') {
      this.countryCode = this._getCountryCode();
    }
  }

  private _getCountryCode(): string | null {
    const localeParts = navigator.language.split('-');
    if (localeParts.length === 2) {
      return localeParts.pop();
    }

    return null;
  }
}
